<mat-form-field *ngIf="model"
                class="full-width"
                [color]="model.getAdditional('color', 'primary')"
                [floatLabel]="model.getAdditional('floatLabel', (FORM_FIELD_OPTIONS && FORM_FIELD_OPTIONS['float']) || 'auto')"
                [formGroup]="group"
                [hideRequiredMarker]="model.getAdditional('hideRequiredMarker', false)"
                [ngClass]="getClass('grid', 'control')"
>
  <ng-container *ngIf="model.label" ngProjectAs="mat-label">
    <mat-label [innerHTML]="model.label"></mat-label>
  </ng-container>
  <mat-chip-grid
    #chipList
    [formControlName]="model.id"
    [required]="model.required"
  >
    <mat-chip-row *ngFor="let chip of model.value; let index = index" (removed)="onChipRemoved(chip)" [value]="chip">
      <span>{{ getLabelForValue(chip) }}</span>

      <mat-icon *ngIf="!model.disabled" class="chip-choice_cancel-icon" matChipRemove>cancel</mat-icon>
    </mat-chip-row>

    <input
      matInput
      #inputElement
      [id]="model.id"
      [matAutocomplete]="auto"
      [matChipInputAddOnBlur]="model.getAdditional('matChipInputAddOnBlur', true)"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="model.getAdditional('matChipInputSeparatorKeyCodes', CHIPS_OPTIONS['separatorKeyCodes'])"
      [placeholder]="placeholder"
      (focus)="showAutocomplete()"
      (blur)="onInputBlur()"
      (keyup)="onKeyUp($event.target.value)"
    >
    <mat-autocomplete
      #auto="matAutocomplete"
      [autoActiveFirstOption]="model.getAdditional('autoActiveFirstOption', AUTOCOMPLETE_OPTIONS['autoActiveFirstOption'])"
      [disableRipple]="model.getAdditional('disableRipple', (RIPPLE_OPTIONS && RIPPLE_OPTIONS['disabled']) || false)"
      [displayWith]="model.getAdditional('displayWith', null)"
      (optionSelected)="onChipSelected($event.option.value)"
    >
      <mat-option *ngFor="let option of options" [value]="option.value">{{ option.label }}</mat-option>
    </mat-autocomplete>
  </mat-chip-grid>
  <mat-hint *ngIf="model.hint !== null" align="start" [innerHTML]="model.hint"></mat-hint>
  <mat-error *ngFor="let message of errorMessages">{{ message }}</mat-error>
</mat-form-field>
